import { STATUS_LABEL } from "@/lib/network";

const COLORS = { AKTIF: "#16A34A", NONAKTIF: "#6B7280", PERBAIKAN: "#F59E0B" };

export function StatusPill({ status, testid }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold" data-testid={testid}>
      <span className="h-2 w-2 rounded-full" style={{ background: COLORS[status] || "#6B7280" }} />
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export const inServerText = (s) => `Di dalam ${s.kode}${s.via ? ` (${s.via.kode})` : ""}${s.has_coords ? "" : ` — Lokasi ${s.label || "SERVER"} belum ditentukan`}`;

// Perangkat di dalam SERVER: lokasi mengikuti SERVER induk (s = {kode, has_coords}).
export function InServerBadge({ s, testid }) {
  return (
    <span className="inline-block rounded border border-[#CBD5E1] bg-[#F1F5F9] px-1.5 py-0.5 text-[10px] font-semibold text-[#1E293B]" data-testid={testid}>
      Di dalam <span className="font-mono-tab">{s.kode}</span>{s.has_coords ? "" : ` — Lokasi ${s.label || "SERVER"} belum ditentukan`}
    </span>
  );
}

// Perangkat di luar SERVER tanpa koordinat tetapi masih punya kabel/relasi.
export function RelocateHint({ show, testid }) {
  if (!show) return null;
  return <p className="rounded border border-dashed border-[#F59E0B] bg-[#FFFBEB] p-2 text-[11px] text-[#92400E]" data-testid={testid}>
    Tetapkan koordinat lewat Edit atau Geser Perangkat agar perangkat dan ujung kabel terkait tampil di peta.</p>;
}

// Kolom PETA: anggota SERVER → "Di dalam KODE"; selain itu ✓ / belum ditentukan.
export function LocCell({ row, testid }) {
  if (row.in_server) return <InServerBadge s={row.in_server} testid={`${testid}-inserver`} />;
  return row.has_coords ? "✓" : <NoCoordBadge testid={testid} />;
}

export function NoCoordBadge({ testid }) {
  return (
    <span className="rounded border border-dashed border-[#F59E0B] bg-[#FFFBEB] px-1.5 py-0.5 text-[10px] font-semibold text-[#B45309]"
          data-testid={testid}>
      Lokasi peta belum ditentukan
    </span>
  );
}

export function PortBar({ used, cap, testid }) {
  const p = cap ? Math.min(100, Math.round((used / cap) * 100)) : 0;
  const color = p >= 100 ? "#DC2626" : p >= 75 ? "#F59E0B" : "#0055FF";
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <div className="h-1.5 w-20 rounded-full bg-[#E5E7EB]">
        <div className="h-1.5 rounded-full" style={{ width: `${p}%`, background: color }} />
      </div>
      <span className="font-mono-tab text-xs">{used}/{cap}</span>
    </div>
  );
}
